module.exports = __webpack_public_path__ + "img/r-177.db0e0606.jpg";